import { memo } from 'react'
import { Grid } from '@material-ui/core'

import UserLogList from '../UserLogList'

const RoleLogList = ({ records = [], objProp = 'name', addedItemColor }) => {
   return (
      <UserLogList records={records} title="Roles Asignados" addedItemColor={addedItemColor}>
         {records?.map((item, index) => (
            <Grid
               container
               style={{ background: item?.new ? addedItemColor : 'transparent' }}
               key={index + item?.[objProp]}
            >
               {item?.[objProp]}
            </Grid>
         ))}
      </UserLogList>
   )
}

export default memo(RoleLogList)
